import { render } from "./Clientes.vue?vue&type=template&id=6666e4af"
import script from "./Clientes.vue?vue&type=script&lang=js"
export * from "./Clientes.vue?vue&type=script&lang=js"

import "./Clientes.vue?vue&type=style&index=0&id=6666e4af&lang=css"

import exportComponent from "/Users/macbookair/Documents/Software Chelita/BAESA/website/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__